enum ClassifiedFuelType {
  Electricity = "ELECTRICITY",
  Hydrogen = "HYDROGEN",
}
export default ClassifiedFuelType;
